import React, {useEffect, useState} from "react";
import { Modal, ModalDialog, Typography, Button, Stack } from "@mui/joy";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {TextField} from "@mui/material";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message?: string;
  isDeleteAction?: boolean;
  enableComments?: boolean;
  onConfirm: (comments?: string) => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (
  {
    open, title = "Confirmación",
    message = "¿Estás seguro de realizar esta acción?",
    isDeleteAction = true,
    enableComments = false,
    onConfirm,
    onCancel
  }) => {

  const [comments, setComments] = useState("");

  useEffect(() => {
    setComments("")
  }, [open]);

  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog
        sx={{width: 600}}
      >
        <Typography level="h4">{title}</Typography>
        <Typography>{message}</Typography>

        {enableComments && (
          <CssVarsProvider>
          <TextField
            fullWidth
            placeholder="Escribe tus comentarios..."
            variant="outlined"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            multiline
            rows={5}
          />
          </CssVarsProvider>
        )}

        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
          <Button variant="outlined" onClick={onCancel} endDecorator={<HighlightOffIcon />}>
            Cancelar
          </Button>
          {isDeleteAction ? (
            <Button variant="solid" color="danger" onClick={() => onConfirm(comments)} endDecorator={<DeleteForeverIcon />}>
              Eliminar
            </Button>
          ) : (
            <Button variant="solid" color="success" onClick={() => onConfirm(comments)} endDecorator={<CheckCircleIcon />}>
              Confirmar
            </Button>
          )}
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmationModal;